import { Navigate, Outlet } from 'react-router-dom';
import NavbarForAdmin from './components/NavbarForAdmin';

const AdminLayout = () => {
  const token = localStorage.getItem('refreshToken');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div>
        <NavbarForAdmin/>
      <main>
        <Outlet /> 
      </main>
    </div>
  );
};

export default AdminLayout;
